import PropTypes from "prop-types";
import { IoClose } from "react-icons/io5";
import { TiTick } from "react-icons/ti";

const RestaurantEdit = (props) => {
    const {
        isLoading,
        userName,
        surName,
        restaurantName,
        email,
        collaborationDescription,
        mobilePhone,
        companyName,
        logo,
        logoError,
        setUserName,
        setSurName,
        setEmail,
        setRestaurantName,
        setCollaborationDescription,
        setMobilePhone,
        setCompanyName,
        handleLogoChange,
        handleSave,
        handleCancel
    } = props;

    return (
        <>
            <section className="border-t border-[#D9D9D9] md:mt-5 md:pt-10 pt-5">
                <h3 className="md:ext-2xl text-xl font-bold mb-2 poppins-medium">Modifica Scheda Ristorante</h3>
                <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5 border-[2px] border-[#8B24332B] sm:p-10 p-5 rounded-xl shadow-md font-sans">
                    <div className="flex flex-col space-y-4 mb-4">
                        <div className="flex md:flex-row flex-col gap-6">
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Nome:
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={userName || ""}
                                    onChange={(e) => setUserName(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Cognome:
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={surName || ""}
                                    onChange={(e) => setSurName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex md:flex-row flex-col gap-6">
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Nome Ristorante:
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={restaurantName || ""}
                                    onChange={(e) => setRestaurantName(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Indirizzo Email:
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={email || ""}
                                    style={{ cursor: "not-allowed" }}
                                    // onChange={(e) => setEmail(e.target.value)}
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className="flex md:flex-row flex-col gap-6">
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Descrizione Collaborazione:
                                </label>
                                <textarea
                                    placeholder="Descrizione Collaborazione"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    rows={6}
                                    value={collaborationDescription?.replace(/<[^>]+>/g, '') || ""}
                                    onChange={(e) => setCollaborationDescription(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col md:w-[50%] w-full space-y-3">
                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Cellulare:
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={mobilePhone || ""}
                                    onChange={(e) => setMobilePhone(e.target.value)}
                                />

                                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                    Ragione Sociale:
                                </label>
                                <input
                                    type="text"
                                    className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none  focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={companyName || ""}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-[50%] space-y-3">
                            <label className="text-sm font-semibold poppins-medium text-[#404040]">
                                Logo:
                            </label>
                            <div className="text-xs text-[#8B8B8B] poppins-regular">
                                Recommended ratio: 249 x 94 px | Max size: 2MB
                            </div>
                            <div className="file-input poppins-regular px-4 py-3 text-[12px] text-[#8B8B8B] rounded-[50px] bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb]">
                                <input type="file" onChange={handleLogoChange} accept="image/*" />
                                <span className="button">Choose</span>
                                <span className="label" data-js-label>No file selected</span>
                            </div>
                            {logoError && (
                                <div className="text-xs text-red-500 mt-1">
                                    {logoError}
                                </div>
                            )}
                            {logo && !logoError && (
                                <div className="overflow-hidden mt-[10px] cursor-pointer h-full w-[100px] flex items-center justify-center">
                                    <img
                                        src={logo}
                                        alt="Preview"
                                        className="w-full object-cover rounded-lg shadow-md"
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex sm:flex-row flex-col text-sm justify-start gap-3 mt-10">
                        {isLoading?.edit ? (
                            <button disabled type="button"
                                className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
                                <svg
                                    aria-hidden="true"
                                    className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                                    viewBox="0 0 100 101"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"
                                    />
                                </svg>
                                Loading...
                            </button>
                        ) : (
                            <button className="sm:w-[120px] w-full flex items-center justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#8B2433] text-[#8B2433] rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                                onClick={handleSave}
                            >
                                <TiTick size={"25px"} color="green" />
                                <span className="poppins-regular">Salva</span>
                            </button>
                        )}

                        <button
                            className="md:w-[120px] w-full flex items-center justify-center space-x-2 p-1 px-3 border-[1.5px] border-[#8B2433] text-[#8B2433] rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                            onClick={handleCancel}
                        >
                            <IoClose size={"25px"} color="red" className="group-hover:invert" />
                            <span className="poppins-regular">Annulla</span>
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
};

RestaurantEdit.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    userName: PropTypes.string,
    surName: PropTypes.string,
    restaurantName: PropTypes.string,
    email: PropTypes.string,
    collaborationDescription: PropTypes.string,
    companyName: PropTypes.string,
    mobilePhone: PropTypes.string,
    setUserName: PropTypes.func.isRequired,
    setSurName: PropTypes.func.isRequired,
    setRestaurantName: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setCollaborationDescription: PropTypes.func.isRequired,
    setMobilePhone: PropTypes.func.isRequired,
    setCompanyName: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    logo: PropTypes.string,
    logoError: PropTypes.string,
    handleLogoChange: PropTypes.func,
};

export default RestaurantEdit;
